import React, { useEffect, useRef, useState } from "react";
import {
  getEnableUsersCount,
  getEnableUsers,
} from "../../apis/SettingApis";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import {
  Spin,
} from "antd";
import {
  SETTING,
  USER_TYPE_ADMIN,
  USER_TYPE_CONTRACTOR,
  USER_TYPE_MANAGER,
  USER_TYPE_QUALITY_CHECKER,
} from "../../utils/constants";
import { useSelector } from "react-redux";
import { Paginator } from "primereact/paginator";
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import RequestProjectCapacityDialog from "./dialog/RequestProjectCapcacityDialog";

const RequestProjectCapacity = () => {
  const [users, setUsers] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [visibleProjectCapacityDialog, setVisibleProjectCapacityDialog] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [basicFirst, setBasicFirst] = useState(0);
  const [totalRows, setTotalRows] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRecords, setTotalRecords] = useState();

  const [showContractor, setShowContractor] = useState(false);
  const [showQCer, setShowQCer] = useState(false);
  const [showFinalChecker, setShowFinalChecker] = useState(false);
  const [colSpanPerDay, setColSpanPerDay] = useState(1);

  const { currentUser = {} } = useSelector(({ app }) => app);
  const dt = useRef(null);
  const toast = useRef(null);

  const fetchPermissions = () => {
    const uniquePermissions = {};
    if (currentUser && currentUser.roles) {
      currentUser.roles.forEach((role) => {
        role.permissions.forEach(
          (permission) => (uniquePermissions[permission.id] = permission)
        );
      });
      setPermissions(Object.values(uniquePermissions));
    }
  };

  const changeVisibleProjectCapacityDialog = (visible) => {
    setVisibleProjectCapacityDialog(visible);
    fetchUsers(pageNumber, totalRows);
  }

  useEffect(() => {
    fetchPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  useEffect(() => {
    if (!currentUser) return;

    if (currentUser.userType === USER_TYPE_CONTRACTOR) {
      setShowContractor(true);
      setColSpanPerDay(1);
    }

    if (currentUser.userType === USER_TYPE_QUALITY_CHECKER) {
      setShowContractor(true);
      setShowQCer(true);
      setColSpanPerDay(2);
    }

    if (currentUser.userType === USER_TYPE_MANAGER || currentUser.userType === USER_TYPE_ADMIN) {
      setShowContractor(true);
      setShowQCer(true);
      setShowFinalChecker(true);
      setColSpanPerDay(3);
    }
  }, [currentUser]);

  const fetchUserCount = () => {
    if (pageNumber >= 0 && totalRows >= 10) {
      setApiLoading(true);
      getEnableUsersCount()
        .then((res) => {
          if (res.status === 200) {
            setTotalRecords(res.data);
            fetchUsers(pageNumber, totalRows);
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    }
  };

  const fetchUsers = (current, pageSize) => {
    setApiLoading(true);
    getEnableUsers(current, pageSize)
      .then((response) => {
        if (response.status === 200) {
          response.data = response.data.sort((u1, u2) => {
            return u1.username.localeCompare(u2.username);
          });
          setUsers(response.data);
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: response.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
    return false;
  };

  useEffect(() => {
  }, []);

  useEffect(() => {
    fetchUserCount();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [pageNumber, totalRows]);

  const onBasicPageChange = (event) => {
    setApiLoading(true);
    setBasicFirst(event.first);
    setPageNumber(event.page);
    setTotalRows(event.rows);
    setApiLoading(false);
  };

  const COLORS = {
    monday: "#FFF0F5",    // Light red
    tuesday: "#F5FFFA",   // Light green
    wednesday: "#F0F8FF", // Light blue
    thursday: "#F0FFF0",  // Light yellow
    friday: "#FFF5EE",    // Light gray
    saturday: "#FFFFE0",     // Light gray
    sunday: "#E5F3FD"     // Light gray
  };

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Id" rowSpan={2} />
        <Column header="Username" rowSpan={2} />
        <Column header="Name" rowSpan={2} />
        <Column header="Unavailable Days" rowSpan={2} />
        <Column header="Monday" colSpan={colSpanPerDay} />
        <Column header="Tuesday" colSpan={colSpanPerDay} />
        <Column header="Wednesday" colSpan={colSpanPerDay} />
        <Column header="Thursday" colSpan={colSpanPerDay} />
        <Column header="Friday" colSpan={colSpanPerDay} />
        <Column header="Saturday" colSpan={colSpanPerDay} />
        <Column header="Sunday" colSpan={colSpanPerDay} />

        <Column header="Action" rowSpan={2} />
      </Row>

      <Row>
        {showContractor && <Column header="Contractor" />}
        {showQCer && <Column header="Qcer" />}
        {showFinalChecker && <Column header="FCer" />}
        {showContractor && <Column header="Contractor" />}
        {showQCer && <Column header="Qcer" />}
        {showFinalChecker && <Column header="FCer" />}
        {showContractor && <Column header="Contractor" />}
        {showQCer && <Column header="Qcer" />}
        {showFinalChecker && <Column header="FCer" />}
        {showContractor && <Column header="Contractor" />}
        {showQCer && <Column header="Qcer" />}
        {showFinalChecker && <Column header="FCer" />}
        {showContractor && <Column header="Contractor" />}
        {showQCer && <Column header="Qcer" />}
        {showFinalChecker && <Column header="FCer" />}
        {showContractor && <Column header="Contractor" />}
        {showQCer && <Column header="Qcer" />}
        {showFinalChecker && <Column header="FCer" />}
        {showContractor && <Column header="Contractor" />}
        {showQCer && <Column header="Qcer" />}
        {showFinalChecker && <Column header="FCer" />}
      </Row>
    </ColumnGroup>
  );

  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
  ];

  const roles = [
    { key: "ContractorCapacity", header: "Contractor", show: showContractor },
    { key: "QcerCapacity", header: "Qcer", show: showQCer },
    { key: "FinalCheckerCapacity", header: "FCer", show: showFinalChecker }
  ];

  const renderCapacityChange = (day, roleKey) => (rowData) => {
    const original =
      rowData.capacityDto?.[`${day}${roleKey}`];

    if(rowData.capacityRequestStatus !== "REQUESTED"){
      return <span>{original}</span>;
    }
    const reqKey =
      `req${day.charAt(0).toUpperCase() + day.slice(1)}${roleKey}`;

    const requested =
      rowData.capacityDto?.[reqKey];

    if (requested != null && requested !== original) {
      return (
        <span>
          {original}
          {" → "}
          <span style={{ color: "red", fontWeight: 600 }}>
            {requested}
          </span>
        </span>
      );
    }

    return <span>{original}</span>;
  };

  return (
    <React.Fragment>
      <div className="user-custom-style">
        <Toast ref={toast} />

        <div>
          <Spin spinning={apiLoading}>
            <Toolbar
              className="mb-4"
              left={() => {
                return (
                  <React.Fragment>
                    <div>
                      <h3 className="m-0">Users</h3>
                    </div>
                  </React.Fragment>
                );
              }}
              right={() => {
                return (
                  <React.Fragment>
                  </React.Fragment>
                );
              }}
            ></Toolbar>
            <DataTable
              ref={dt}
              value={users}
              dataKey="id"
              responsiveLayout="scroll"
              headerColumnGroup={headerGroup}
            >
              <Column field="id" header="ID" />
              <Column field="username" header="Username" />
              <Column field="name" header="Name" />
              <Column
                header="Unavailable Days"
                body={(rowData) => {
                  const original = rowData.dayOffs;
                  const requested = rowData.requestedDayOffs;

                  if (requested && requested !== original) {
                    return (
                      <span>
                        {original}
                        {" → "}
                        <span style={{ color: "red", fontWeight: 600 }}>
                          {requested}
                        </span>
                      </span>
                    );
                  }

                  return original;
                }}
              />
              {days.map((day) =>
                roles.filter(role => role.show).map((role) => (
                  <Column
                    key={`${day}-${role.key}`}
                    header={role.header}
                    style={{ backgroundColor: COLORS[day] }}
                    body={renderCapacityChange(day, role.key)}
                  />
                ))
              )}

              <Column
                field="action"
                header="Action"
                body={(record) => {
                  return (
                    <React.Fragment>
                      <div className="flex justify-content-center">
                        {permissions.map((permission) => {
                          return permission.name === SETTING ? (
                            <div>
                              <Button
                                style={{
                                  backgroundColor: "#037EEA",
                                  borderColor: "#037EEA",
                                }}
                                icon={"pi pi-pencil"}
                                label="Request Change"
                                onClick={(event) => {
                                  event.preventDefault();
                                  setSelectedUser(record);
                                  setVisibleProjectCapacityDialog(true);
                                }}
                              />
                            </div>
                          ) : (
                            ""
                          );
                        })}
                      </div>
                    </React.Fragment>
                  );
                }}
              />
            </DataTable>
            <Paginator
              first={basicFirst}
              rows={totalRows}
              totalRecords={totalRecords}
              rowsPerPageOptions={[10, 20, 30]}
              onPageChange={onBasicPageChange}
            ></Paginator>
          </Spin>
        </div>

      </div>
      <RequestProjectCapacityDialog
        user={selectedUser}
        visible={visibleProjectCapacityDialog}
        setVisible={changeVisibleProjectCapacityDialog}
        showContractor={showContractor}
        showQCer={showQCer}
        showFinalChecker={showFinalChecker}
      >
      </RequestProjectCapacityDialog>
    </React.Fragment>
  );
};

export default RequestProjectCapacity;
